import Domains from './Domains';
import Heart from './Heart';
import Home from './Home';
import Key from './Key';
import PlatformRoles from './PlatformRoles';
import Users from './Users';
import Reports from './Reports';
import Teams from './Teams';
import Visibility from './Visibility';
import VisibilityOff from './VisibilityOff';
import Settings from './Settings';

export { default as Domains } from './Domains';
export { default as Heart } from './Heart';
export { default as Home } from './Home';
export { default as Key } from './Key';
export { default as PlatformRoles } from './PlatformRoles';
export { default as Users } from './Users';
export { default as Reports } from './Reports';
export { default as Teams } from './Teams';
export { default as Visibility } from './Visibility';
export { default as VisibilityOff } from './VisibilityOff';
export { default as Settings } from './Settings';

export default {
  Domains,
  Heart,
  Home,
  Key,
  PlatformRoles,
  Users,
  Reports,
  Teams,
  Visibility,
  VisibilityOff,
  Settings,
};
